<template>
  <!-- 退出登录 -->
  <div class="tuichuden" v-if="show">
    <div class="annou">
      <h1>{{title}}</h1>
      <p>{{message}}</p>
      <dl class="two" v-if="btn=='que,qu'">
        <dt @click="quxiao">{{quxiaoName}}</dt>
        <dd @click="quit">{{quitName}}</dd>
      </dl>
      <dl  v-if="btn=='qu'">
        <dt @click="quxiao">{{quxiaoName}}</dt>
      </dl>
      <dl class="two" v-if="btn=='que'">
        <dd @click="quit">{{quitName}}</dd>
      </dl>
    </div>
    <!-- <div class="annou">
      <p>您确定要退出登录吗？</p>
    </div> -->
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String
      },
      message: {
        type: String
      },
      fun: {
        type: String,
        default:'quxiao'
      },
      obj: {
        type: Object
      },
      flag: {
        type: Boolean
      },
      btn: {
        type: String
      },
      quxiaoName:{
        type: String,
        default:"取消"
      },
      quitName:{
        type: String,
        default:"确认"
      },
      quxiaofun:{
        type: Function,
        default:null
      },

    },
    watch: {
      flag(va) {
        console.log("flag="+va)
        this.show = va;
      },
      btn(va) {
        this.btn = va;
      }
    },
    data() {
      return {
        show: false
      }
    },
    created() {
      console.log('1111')
      let _this = this;
      this.show =true;
      if(this.btn == ''){
        setTimeout(function(){
          _this.show = false
        },2000)
      }
    },
    methods: {
      quxiao() {
        if(this.quxiaoName!="取消"){
          // this.quxiaofun()
        } else {
          this.$emit('close')
        }
        this.$emit('close')
        //this.show = false;
      },
      quit() {
        this.show = false;
        if (this.fun != null&&this.fun != '') {
          console.log(this.fun)
          this.$emit(this.fun, this.obj)
        }
      }
    }
  }
</script>

<style scoped>
  /* 退出登录 */
  .tuichuden {
    z-index: 121;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgb(0 0 0 / 21%);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    justify-content: center;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: rgb(235 232 230);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .one{
    width: 50%;
    height: 40px;
    border-radius: 20px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    opacity: 1;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .annou .two dd {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 2px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    margin-left: 20px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/toast.vue